__turbopack_context__.v({
  "modal-content": "hotline-modal-module-scss-module__u_bXda__modal-content",
  "placeholder": "hotline-modal-module-scss-module__u_bXda__placeholder",
  "text": "hotline-modal-module-scss-module__u_bXda__text",
});
